import { Providers } from '@ab-core/abds-provider';
import type { GatsbyBrowser } from 'gatsby';
import React from 'react';

export const abWrapRootElement: GatsbyBrowser['wrapRootElement'] = (props) => {
    const { element } = props;

    return <Providers>{element}</Providers>;
};
